import {observer} from "mobx-react";
import {DocumentTypeDto, ScanStatusDto} from "../../../api/sea";
import {convertDocumentType, convertScanStatus} from "../../../api";
import {seaDocumentDetailStore} from "../../../store";
import {ReactNode} from "react";
import {Linq} from "../../ui";

function dateFormat(date: string | undefined): string {
    if (!date) {
        return ''
    }
    return new Date(date).toLocaleString('de')
}

const ScanDetailData = observer(function ScanDetailData() {
    const {
        auditLastModifiedDate,
        scanCode,
        stackId,
        customer,
        recordId,
        scanDate,
        status,
        documentId,
        customerNumber,
        type,

        documentNumber,
        vin,
        pageCount,
        position,
        licensePlate,
        dateOfDeRegistration,
        dateOfRegistration,
        firstDateOfRegistration,
        receiver
    } = seaDocumentDetailStore
    const data: { label: string | ReactNode, value: string | ReactNode }[] = [
        {
            label: <strong>Fahrzeug</strong>,
            value: <>
                {customer && <Linq
                    to={`/vhs/${customer?.customerId}/${vin}`}><span
                    className="material-symbols-outlined has-text-link">link</span></Linq>}
            </>
        },
        {
            label: 'Dokumentenart',
            value: convertDocumentType(type)
        },
        {
            label: 'Dokument',
            value: `${documentId}`
        },
        {
            label: 'Anzahl Seiten',
            value: `${pageCount}`
        },
        {
            label: 'Scan Code',
            value: `${scanCode}`
        },
        {
            label: 'Scan Datum',
            value: `${dateFormat(scanDate)}`
        },
        {
            label: 'Stapel/Masterfile',
            value: `${stackId}`
        },
        {
            label: 'Position',
            value: `${position}`
        },
        {
            label: 'Stapelstatus',
            value: `${convertScanStatus(status as ScanStatusDto)}`
        },
        {
            label: 'Akte',
            value: `${recordId}`
        },
        {
            label: 'Kunde',
            value: customer ? `${customer.name} (${customer.displayName}) [${customer.customerNumber}]` : `${customerNumber}`
        },
        {
            label: 'Letzte Änderung',
            value: dateFormat(auditLastModifiedDate)
        },
    ]

    if (documentNumber) {
        data.push({
            label: type === DocumentTypeDto.COR_I ? 'Scheinnummer' : 'Briefnummer',
            value: documentNumber
        })
    }
    if (vin) {
        data.push({
            label: 'Fahrgestellnummer',
            value: vin
        })
    }
    if (licensePlate) {
        data.push({
            label: 'Nummernschild',
            value: licensePlate
        })
    }
    if (firstDateOfRegistration) {
        data.push({
            label: 'Erstzulassungsdatum',
            value: dateFormat(firstDateOfRegistration)
        })
    }
    if (dateOfRegistration) {
        data.push({
            label: 'Zulassungsdatum',
            value: dateFormat(dateOfRegistration)
        })
    }
    if (dateOfDeRegistration) {
        data.push({
            label: 'Abmeldedatum',
            value: dateFormat(dateOfDeRegistration)
        })
    }
    if (receiver) {
        data.push({
            label: 'Empfänger',
            value: `${receiver.namePrimary || ''}${receiver.nameSecondary ? ` ${receiver.nameSecondary}` : ''}, 
            ${receiver.address?.street || ''} ${receiver.address?.houseNumber || ''} ${receiver.address?.addressAddition || ''} 
            ${receiver.address?.postcode || ''} ${receiver.address?.city || ''}`.trim()
        })
    }


    return <div>
        <table className={"table is-fullwidth"} style={{fontSize: '0.8em'}}>
            <tbody>
            {data.map((e, index) => <tr key={index}>
                <td style={{width: '10em'}}>{e.label}</td>
                <td>{e.value}</td>
            </tr>)}
            </tbody>
        </table>
    </div>
})

export {
    ScanDetailData
}
